export const purchasingItem = state => {
  return state.purchasingItem;
};
